exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-container[data-v-7a72b888]{width:100%;height:100%;padding-top:220px;background-color:#fff\n}\n.page-container .error-image[data-v-7a72b888]{width:100%;height:200px;background-position:center;background-repeat:no-repeat\n}\n.page-container .text-content[data-v-7a72b888]{width:100%;text-align:center\n}\n.page-container .text-one[data-v-7a72b888]{padding-top:24px;padding-bottom:12px;font-size:20px;color:#2f2f4f;font-weight:bold\n}\n.page-container .text-two[data-v-7a72b888]{font-size:14px;color:#697386\n}\n.page-container .text-link[data-v-7a72b888]{padding-top:35px;padding-bottom:40px;font-size:16px;color:#0066ff\n}\n", ""]);

// exports
